var canx = document.createElement("CANVAS");
canx.height = 100;
canx.width = 100;
var ctx = canx.getContext("2d");
var canxData;

export async function createImage(letter) {//completeUser.name.charAt(0);
    let l;
    if (arguments.length) { l = letter } else { l = "?" };
    let b = Math.floor(Math.random() * 16777215).toString(16); //update color generation here
    let c = getContrast(b);

    ctx.fillStyle = "#" + b;
    ctx.fillRect(0, 0, canx.width, canx.height);
    ctx.font = "900 60px Sofia Sans, Montserrat, Sans-serif"; //Sofia Sans, 
    ctx.textAlign = "center";
    ctx.fillStyle = "#" + c;
    ctx.fillText(l, 50, 72);

    canxData = canx.toDataURL().replace('data:image/png;base64,', '');
    return canxData;
}

function getContrast(hexcolor) {
    hexcolor = hexcolor.replace("#", "");
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    let rgb = r + g + b;
    if (rgb > 750) {
        return 'ff0000';
    } else if (rgb < 15) {
        return "00ff00";
    } else {
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? '000000' : 'ffffff';
    }
}
